import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { motion } from 'framer-motion';
import { Download, Smartphone, ShieldCheck, BookOpenIcon, ExternalLinkIcon, TagIcon } from 'lucide-react';
export function EbookPurchase() {
  return <section className="bg-warm-beige py-24 px-6" data-id="element-77">
      <div className="max-w-5xl mx-auto space-y-10" data-id="element-78">
        {/* Ebook Section */}
        <AnimatedSection className="bg-white rounded-3xl shadow-warm-lg overflow-hidden flex flex-col md:flex-row" data-id="element-79">
          {/* Left side - Visual */}
          <div className="md:w-2/5 bg-deeper-beige p-12 flex items-center justify-center relative" data-id="element-80">
            <div className="absolute inset-0 bg-gradient-to-br from-amber/10 to-terracotta/10" data-id="element-81"></div>
            <div className="relative w-full max-w-[200px] rounded-xl shadow-warm-lg overflow-hidden transform -rotate-2 hover:rotate-0 transition-transform duration-500 bg-deep-brown" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/fTt7DvZ6cZM2cKcYa4N9ri/ROMPIENDO_EL_SILENCIO.jpg" alt="Portada del ebook Rompiendo el Silencio" className="w-full h-auto block" data-id="element-83" />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="md:w-3/5 p-10 md:p-12 flex flex-col justify-center" data-id="element-84">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-85">
              Obtén Tu Copia Digital
            </h2>
            <p className="text-lg text-medium-brown mb-8" data-id="element-86">
              Comienza tu viaje de sanación hoy mismo. Descarga instantánea
              compatible con todos tus dispositivos.
            </p>

            {/* Discount Badge */}
            <div className="inline-flex items-center gap-2 bg-terracotta/10 text-terracotta px-4 py-2 rounded-full text-sm font-semibold mb-4 w-fit" data-id="element-87">
              <TagIcon className="w-4 h-4" data-id="element-88" />
              ¡Oferta por tiempo limitado!
            </div>

            {/* Pricing with discount */}
            <div className="flex items-center gap-4 mb-8" data-id="element-89">
              <span className="text-2xl text-light-brown line-through font-medium" data-id="element-90">
                $14.99
              </span>
              <span className="text-5xl font-bold text-deep-brown" data-id="element-91">$7.99</span>
              <span className="text-lg text-medium-brown font-medium" data-id="element-92">USD</span>
              <span className="bg-terracotta text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-93">
                -47%
              </span>
            </div>

            <ul className="space-y-4 mb-8" data-id="element-94">
              <li className="flex items-center text-medium-brown" data-id="element-95">
                <Download className="w-5 h-5 text-terracotta mr-3 flex-shrink-0" data-id="element-96" />
                Descarga inmediata en formato PDF y EPUB
              </li>
              <li className="flex items-center text-medium-brown" data-id="element-97">
                <Smartphone className="w-5 h-5 text-terracotta mr-3 flex-shrink-0" data-id="element-98" />
                Lee en tu tablet, teléfono o e-reader
              </li>
              <li className="flex items-center text-medium-brown" data-id="element-99">
                <ShieldCheck className="w-5 h-5 text-terracotta mr-3 flex-shrink-0" data-id="element-100" />
                Pago 100% seguro y confidencial
              </li>
            </ul>

            <motion.a href="https://rompiendo-el-silencio-2.myshopify.com/products/rompiendo-el-silencio" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full block text-center bg-terracotta text-white py-4 rounded-xl font-semibold text-lg shadow-warm hover:bg-terracotta-dark transition-colors duration-300 mb-6" data-id="element-101">
              Comprar Ebook — $7.99
            </motion.a>

            {/* Payment Icons */}
            <div className="flex items-center justify-center space-x-4 text-sm font-medium text-light-brown" data-id="element-102">
              <div className="px-3 py-1 border border-light-brown/30 rounded" data-id="element-103">
                Visa
              </div>
              <div className="px-3 py-1 border border-light-brown/30 rounded" data-id="element-104">
                Mastercard
              </div>
              <div className="px-3 py-1 border border-light-brown/30 rounded" data-id="element-105">
                PayPal
              </div>
              <div className="px-3 py-1 border border-light-brown/30 rounded" data-id="element-106">
                Stripe
              </div>
            </div>
          </div>
        </AnimatedSection>

        {/* Physical Book Section */}
        <AnimatedSection className="bg-white rounded-3xl shadow-warm-lg p-10 md:p-12" data-id="element-107">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-108">
            <div className="flex-shrink-0 w-16 h-16 bg-amber/20 rounded-2xl flex items-center justify-center" data-id="element-109">
              <BookOpenIcon className="w-8 h-8 text-terracotta" data-id="element-110" />
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-111">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-112">
                También Disponible en Libro Físico
              </h3>
              <p className="text-medium-brown text-lg leading-relaxed" data-id="element-113">
                ¿Prefieres tener el libro en tus manos?{' '}
                <strong data-id="element-114">Rompiendo el Silencio</strong> también está disponible
                en formato físico a través de Amazon. Recíbelo directamente en
                tu hogar.
              </p>
            </div>
            <motion.a href="https://www.amazon.com/ROMPIENDO-EL-SILENCIO-Sobreviviente-Empoderamiento/dp/B0D7T725FF" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="flex-shrink-0 inline-flex items-center gap-2 bg-deep-brown text-cream px-8 py-4 rounded-xl font-semibold text-lg shadow-warm hover:bg-medium-brown transition-colors duration-300" data-id="element-115">
              Comprar en Amazon
              <ExternalLinkIcon className="w-5 h-5" data-id="element-116" />
            </motion.a>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}